import { Button, IconButton, useMediaQuery, useTheme } from "@mui/material";
import ExploreIcon from "@mui/icons-material/Explore";
import React from "react";

interface ExploreButtonProps {
  onExplore: () => void;
}

export default function ExploreButton({ onExplore }: ExploreButtonProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        onClick={onExplore}
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          "&:hover": {
            backgroundColor: "primary.dark",
          },
        }}
      >
        <ExploreIcon />
      </IconButton>
    );
  }

  return (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<ExploreIcon />}
      onClick={onExplore}
    >
      Explore
    </Button>
  );
}
